export const config = {
  apiKey: "AIzaSyDNioFIYef_g8p7hEO0brrgWAA3eQuYug4",
  projectId: "gosselin-scw",
  databaseURL: "https://gosselin-scw.firebaseio.com",
  authDomain: "gosselin-scw.firebaseapp.com",
  storageBucket: 'gs://gosselin-scw.appspot.com/'
};
